export const services = [
    {
       image : "assets/img/service/1.svg",
       title : "Dashboard",
       description : "Acompanhe todas as vendas geradas por você.",
       url: "https://afiliado.parceirando.com.br/material-de-apoio"
    },
    {
        image : "assets/img/service/2.svg",
        title : "Pedidos",
        description : "Filtre, veja o que já foi marcados pelos lojistas.",
        url: "https://afiliado.parceirando.com.br/material-de-apoio#h.1indqzofyzpn"
     },
     {
        image : "assets/img/service/3.svg",
        title : "Minisite",
        description : "Minisite com produtos do lojista para divulgar.",
        url: "https://afiliado.parceirando.com.br/material-de-apoio#h.ndtuj1ca77j0"        
     },
     {
        image : "assets/img/service/4.svg",
        title : "Global",
        description : "Seja um afiliado global, busque lojas e seja visto.",
        url: "https://afiliado.parceirando.com.br/material-de-apoio#h.nftq1mcqw9mp"
     },
] 